import type { JSX } from 'react';

import { ToastContainer } from 'react-toastify';
import { TopBar } from './components';

import './Layout.styles.css';
import classnames from 'classnames';

type LayoutProps = {
  children?: JSX.Element;
  leftSidebar?: JSX.Element | null;
  rightSidebar?: JSX.Element | null;
};

export default function Layout({ children, leftSidebar, rightSidebar }: LayoutProps) {
  return (
    <div className="layout-container">
      <TopBar />
      <div className="layout-content">
        {leftSidebar && (
          <div className="layout-left-sidebar">
            <div className="layout-left-sidebar-content">{leftSidebar}</div>
          </div>
        )}
        <div className="layout-main">
          <div
            className={classnames('layout-main-content', {
              'one-sidebar':
                (leftSidebar && !(leftSidebar && rightSidebar)) ||
                (rightSidebar && !(leftSidebar && rightSidebar)),
              'two-sidebars': leftSidebar && rightSidebar,
            })}
          >
            {children}
          </div>
        </div>
        {rightSidebar && (
          <div className="layout-right-sidebar">
            <div className="layout-right-sidebar-content">{rightSidebar}</div>
          </div>
        )}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
        theme="colored"
      />
    </div>
  );
}
